import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import ContentHeader from '../ContentHeader'
import StaticButtonBar from './StaticButtonBar'
import { PageLoader } from '../loaders'
import { connect } from 'react-redux'
import mapLoadingKeysToState from '../../utils/mapLoadingKeysToState'

import styled from '@emotion/styled'

const StyledSection = styled('section')`
  margin: 0 auto;
  max-width: 352px;
  width: 100%;
`

const StaticSection = ({ children, loading, ...rest }) => (
  <Fragment>
    <StyledSection {...rest}>{children}</StyledSection>
    <PageLoader {...loading} />
  </Fragment>
)

StaticSection.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.shape({
    message: PropTypes.string,
    show: PropTypes.bool,
    success: PropTypes.bool,
  }),
}

StaticSection.Header = ContentHeader
StaticSection.ButtonBar = StaticButtonBar

export default connect(mapLoadingKeysToState)(StaticSection)
